<template>
  <div class="slider-colour-picker">
    <div class="hue-warp">
      <hue-strip v-model="colour" @change="hueChange"/>
    </div>
    <div class="swatches">
      <div class="swatch"
        v-for="(offset, index) in swatches"
        :key="index"
        @click="selectSwatch(index, offset)">
        <div
          class="swatch-picker"
          :class="{
            'is-active': offset == activeOffset,
            'is-white': offset === '1'
          }"
          :style="{
            background: `hsl(${colour.hsl.h}, 50%, ${offset * 100}%)`
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { colour } from '../../mixins/colour'

export default {
  mixins: [
    colour
  ],

  props: {
    swatches: {
      type: Array,
      default: () => ['.80', '.70', '.60', '.50', '.40', '.30']
    }
  },

  computed: {
    activeOffset() {
      let hasBlack = this.swatches.includes('0'),
        hasWhite = this.swatches.includes('1'),
        hsl = this.colour.hsl

      if (Math.round(hsl.s * 100) / 100 === 0.50) {
        return Math.round(hsl.l * 100) / 100
      } else if (hasBlack && hsl.l === 0) {
        return 0
      } else if (hasWhite && hsl.l === 1) {
        return 1
      }
      return -1
    }
  },
  methods: {
    hueChange(data) {
      this.changeColour(data)
      if (this.activeOffset < 0) {
        let middleIndex = Math.floor(this.swatches.length / 2),
          middleSwatch = this.swatches[middleIndex]
        this.selectSwatch(middleIndex, middleSwatch)
      }
    },
    selectSwatch(index, offset) {
      this.changeColour({
        h: this.colour.hsl.h,
        s: 0.5,
        l: offset,
        source: 'hsl'
      })
    }
  }
}
</script>
